// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"732":"a1efa844","977":"444f19c5"}[chunkId] + ".chunk.js");